





















import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';

import { useDeclination } from '~/diptyqueTheme/composable/useDeclination';
import { useLink } from '~/diptyqueTheme/composable/useLink';
import type { MediaPreloadableSection } from '~/diptyqueTheme/types/components';
import type { EditorialCardModel } from '~/diptyqueTheme/types/contentful';
import { isValidRatio } from '~/helpers/ratioValueValidatior';

export default defineComponent({
  name: 'EditorialCard',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    //it's used dynamically
    // eslint-disable-next-line vue/no-unused-components
    SfLink
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<EditorialCardModel & MediaPreloadableSection>
    }
  },
  setup(props) {
    const { normalizeLink } = useLink();
    const { getBannerData: bannerData } = useDeclination(props.sectionData);
    const DEFAULT_RATIO = '3:4';

    const getRatio = (ratio: string | undefined): string => {
      return isValidRatio(ratio) ? ratio : DEFAULT_RATIO;
    };
    /**
     * Computes the aspect ratio for mobile and desktop based on the section data.
     * If the ratio is invalid, it defaults to predefined values.
     */
    const aspectRatio = computed<{
      mobile: string;
      desktop: string;
    }>(() => {
      const { visualRatioOnMobile, visualRatioOnDesktop } = props.sectionData;

      return {
        mobile: getRatio(visualRatioOnMobile),
        desktop: getRatio(visualRatioOnDesktop)
      };
    });

    return {
      bannerData,
      aspectRatio,
      normalizeLink
    };
  }
});
